export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  cmsWorkbench: 'cmsWorkbench',
  cmsOperation: 'cmsOperation',
  cmsContent: 'cmsContent',
  cmsAi: 'cmsAi',
  cmsSite: 'cmsSite',
  cmsChannel: 'cmsChannel',
  cmsSeo: 'cmsSeo',
  cmsMaterial: 'cmsMaterial',
  cmsLead: 'cmsLead',
  cmsAnalytics: 'cmsAnalytics',
  cmsProduct: 'cmsProduct',
  cmsIntegration: 'cmsIntegration',
} as const;

const standardActions = {
  view: 'view',
  create: 'create',
  edit: 'edit',
  submitReview: 'submitReview',
  review: 'review',
  publish: 'publish',
  withdraw: 'withdraw',
  export: 'export',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  cmsWorkbench: { view: 'view' },
  cmsOperation: standardActions,
  cmsContent: standardActions,
  cmsAi: {
    view: 'view',
    create: 'create',
    acceptSuggestion: 'acceptSuggestion',
  },
  cmsSite: standardActions,
  cmsChannel: standardActions,
  cmsSeo: {
    view: 'view',
    create: 'create',
    edit: 'edit',
    diagnose: 'diagnose',
    createTask: 'createTask',
    manageTask: 'manageTask',
  },
  cmsMaterial: {
    ...standardActions,
    upload: 'upload',
    delete: 'delete',
  },
  cmsLead: {
    view: 'view',
    assign: 'assign',
    viewSensitive: 'viewSensitive',
    convertCrm: 'convertCrm',
    export: 'export',
  },
  cmsAnalytics: { view: 'view', export: 'export' },
  cmsProduct: standardActions,
  cmsIntegration: {
    view: 'view',
    manageKey: 'manageKey',
    manageWebhook: 'manageWebhook',
    viewLog: 'viewLog',
  },
} as const;
